/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fish'
export default icon
